export default "__VITE_ASSET__C4KTK_FV__"